<script setup lang="ts">
import CheckMarkIcon from 'assets/images/svg/checkmark.svg';

const event = await queryContent('/event').findOne()
</script>

<template>
  <section class="main-event">
    <div class="container">
      <h2 class="main-event__title main-event__title-mobile text-40">
        {{ event.title }}
      </h2>
      <div class="main-event__row">
        <div class="main-event__image-wrapper">
          <NuxtImg
            class="main-event__img"
            src="/img/other/main-event.png"
            alt="Фон"
            loading="lazy"
            format="webp"
          />
        </div>
        <div class="main-event__text-wrapper">
          <h2 class="main-event__title main-event__title-desktop text-40">
            {{ event.title }}
          </h2>
          <ul class="main-event__list">
            <li v-for="(item, index) in event.list" :key="index" class="main-event__list-item">
              <CheckMarkIcon />
              <p class="text-20 main-event__list-text">{{ item }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.main-event {
  &__row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: center;

    @media (max-width: $x-small) {
      grid-template-columns: auto;
    }
  }

  @media (max-width: $small) {
    padding: 40px 0;
  }

  @media (max-width: $x-small) {
    padding: 36px 0;
  }

  &__image-wrapper {
    position: relative;
    height: 642px;

    @media (max-width: $large) {
      height: 492px;
    }

    @media (max-width: $small) {
      height: 289px;
    }

    @media (max-width: $x-small) {
      display: none;
    }
  }

  &__img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  &__title {
    max-width: 780px;

    &-mobile {
      display: none;
    }

    @media (max-width: $small) {
      &-desktop {
        display: none;
      }

      &-mobile {
        display: block;
        margin-bottom: 29px;

        @media (max-width: $x-small) {
          margin-bottom: 26px;
        }
      }
    }
  }

  &__list {
    margin-top: 84px;

    @media (max-width: $large) {
      margin-top: 56px;
    }

    @media (max-width: $small) {
      margin-top: 0;
    }

    &-text {
      max-width: 700px;
    }

    &-item {
      display: flex;
      gap: 27px;

      &:not(:last-child) {
        margin-bottom: 40px;

        @media (max-width: $large) {
          margin-bottom: 32px;
        }

        @media (max-width: $small) {
          margin-bottom: 28px;
        }
      }

      svg {
        flex: 0 0 18px;
        margin-top: 6px;
      }
    }
  }
}
</style>
